// src/components/pages/Lab/LabExpandedContent.tsx
import React, { useState } from 'react'
import LabSharedTable from './LabSharedTable'
import { LabOrder } from '@dataTypes/lab.types'
import { Modal } from 'react-bootstrap'
import Button from '@components/common/Button/Button.component'

type LabExpandedContentProps = {
  lab: LabOrder
}

const LabExpandedContent: React.FC<LabExpandedContentProps> = ({ lab }) => {
  const [selectedInstruction, setSelectedInstruction] = useState<string | null>(
    null,
  )
  const [showInstructionModal, setShowInstructionModal] = useState(false)

  const columns = [
    {
      key: 'procedureType',
      label: 'Procedure Type',
      style: { width: '200px' },
      formatter: (val: string) => val || '—',
    },
    {
      key: 'region',
      label: 'Region',
      style: { width: '140px' },
      formatter: (val: string) => val || '—',
    },
    {
      key: 'material',
      label: 'Material',
      style: { width: '140px' },
      formatter: (val: string) => val || '—',
    },
    {
      key: 'shadeNo',
      label: 'Shade No.',
      style: { width: '140px' },
      formatter: (val: string) => val || '—',
    },
    {
      key: 'instructions',
      label: 'Instructions',
      style: { width: '250px' },
      formatter: (val: string) =>
        val ? (
          <button
            className="button-link p-0 text-primary text-small"
            onClick={() => {
              setSelectedInstruction(val)
              setShowInstructionModal(true)
            }}
          >
            View
          </button>
        ) : (
          '—'
        ),
    },
    {
      key: 'spacer1',
      label: '',
      style: { width: '150px' },
      formatter: () => '',
    },
    {
      key: 'spacer2',
      label: '',
      style: { width: '120px' },
      formatter: () => '',
    },
    {
      key: 'spacer3',
      label: '',
      style: { width: '150px' },
      formatter: () => '',
    },
  ]

  return (
    <div className="expanded-content-wrapper">
      <LabSharedTable
        columns={columns}
        data={lab.prescriptions || []}
        className="expanded-table custom-expanded-header"
        pageSize={5}
      />

      <Modal
        show={showInstructionModal}
        onHide={() => setShowInstructionModal(false)}
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Instructions</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p style={{ whiteSpace: 'pre-wrap' }}>{selectedInstruction}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => setShowInstructionModal(false)}
            className="button-md button-secondary"
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}

export default React.memo(LabExpandedContent)
